/** Free-text delivery info (stored as `delivery_date_` / JSON `deliveryDate` or `delivery_date`). */
export function getOrderDeliveryText(
  order: { deliveryDate?: string | null; delivery_date?: string | null } | null | undefined
): string {
  if (!order) return "";
  const raw = order.deliveryDate ?? order.delivery_date;
  if (raw === undefined || raw === null) return "";
  const s = String(raw).trim();
  if (!s || s === "null" || s === "undefined") return "";
  return s;
}
